import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "306",
  "slug": "spot-kenya-from-satellite-imagery",
  "title": "How to Recognise Kenya in Satellite Images",
  "excerpt": "Kenya includes central highlands, Rift Valley lakes, dry northern and eastern lowlands, and an Indian Ocean coast.",
  "date": "2026-04-01",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/kenya.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Kenya includes central highlands, Rift Valley lakes, dry northern and eastern lowlands, and an Indian Ocean coast. Mount Kenya rises east of the Rift. These contrasts mean that a lush highland image and a dry northern image can both belong to Kenya."
    },
    {
      "type": "heading",
      "text": "The Rift and the central highlands"
    },
    {
      "type": "paragraph",
      "text": "Compare the highlands around Mount Kenya with the terrain around Lake Turkana. Describe the visible contrast without assuming one image represents the whole country."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Tanzania and Ethiopia share rift landscapes and volcanic highlands. Scattered trees on grassland do not identify the country. Look at the form of the basin, nearby lakes, and the position of higher ground."
    }
  ],
  "imageAlt": "Kenya regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
